import React from 'react';

interface ResultItemSkeletonProps {
  variant?: 'trail' | 'event' | 'attraction';
}

export const ResultItemSkeleton: React.FC<ResultItemSkeletonProps> = ({ 
  variant = 'trail' 
}) => {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-3 animate-pulse">
      {/* Title skeleton */}
      <div className="h-5 bg-slate-200 rounded w-2/3 mb-2"></div>
      
      {/* Metadata badges skeleton */}
      <div className="flex gap-2 mb-2 flex-wrap">
        <div className="h-5 bg-slate-200 rounded w-16"></div>
        <div className="h-5 bg-slate-200 rounded w-20"></div>
      </div>
      
      {/* Description skeleton - 2 lines instead of 3 */}
      <div className="space-y-1.5 mb-2">
        <div className="h-3 bg-slate-200 rounded w-full"></div>
        <div className="h-3 bg-slate-200 rounded w-3/4"></div>
      </div>
    </div>
  );
};

